/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import * as thunks from './thunks';
import { CrmSalesColumnState, CrmSalesState, CrmSalesStatus } from './types';

const createInitialColumnState = (): CrmSalesColumnState => ({
  tickets: [],
  loading: false,
  hasMore: false,
  error: null
});

const initialState: CrmSalesState = {
  columns: {
    Lead: createInitialColumnState(),
    Warm: createInitialColumnState(),
    Engage: createInitialColumnState(),
    Prospect: createInitialColumnState(),
    'Close Deal': createInitialColumnState(),
    Lost: createInitialColumnState()
  }
};

const getColumn = (state: CrmSalesState, status?: CrmSalesStatus) => {
  if (!status) return undefined;
  return state.columns[status];
};

const slice = createSlice({
  name: 'crm-sales',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(thunks.fetchCrmSalesTicket.pending, (state, action) => {
        const column = getColumn(state, action.meta.arg?.status);

        if (column) {
          column.loading = true;
          column.error = null;
        }
      })
      .addCase(thunks.fetchCrmSalesTicket.fulfilled, (state, action) => {
        const column = getColumn(state, action.meta.arg?.status);

        if (column) {
          const tickets = action.payload.data ?? [];

          column.tickets = action.meta.arg?.append
            ? [...column.tickets, ...tickets]
            : tickets;
          column.loading = false;
          column.hasMore = Boolean(
            action.meta.arg?.limit && tickets.length >= action.meta.arg.limit
          );
          column.error = null;
        }
      })
      .addCase(thunks.fetchCrmSalesTicket.rejected, (state, action) => {
        const column = getColumn(state, action.meta.arg?.status);

        if (column) {
          column.loading = false;
          column.error =
            action.error.message ?? 'Failed to fetch CRM sales tickets';
        }
      });
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
